import { createContext, useContext } from "react"

const ProjectContext = createContext({})

export const useProjectContext = () => useContext(ProjectContext)

export default ProjectContext
